export interface ReportReviewReasons {
  factuallyIncorrectDetailsAboutPropertyOrAmenities: boolean
  offensiveLanguageOrAbusiveContent: boolean
  unrelatedToActualStay: boolean
  privacyConcernPersonalInformationDisclosed: boolean
  reviewInResponseToPolicyEnforcement: boolean
  other: boolean
}

export const PENDING = "PENDING"
export const APPROVED = "APPROVED"
export const REJECTED = "REJECTED"
